import datamethods from '../datamethods.js'
import {mapFields} from 'vuex-map-fields'
import format from '../format.js'
export default {
    mixins:[datamethods,format],
    data(){
        return{
            //photos
            capturedPerson:null,
            capturedPersonURL:null,
            hasImagePerson:true,

            capturedLicenseFront:null,
            capturedLicenseFrontURL:null,
            hasLicenseFront:true,

            capturedLicenseBack:null,
            capturedLicenseBackURL:null,
            hasLicenseBack:true,

            capturedVaccineCard:null,
            capturedVaccineCardURL:null,
            hasVaccineCard:true,

            backLinkText:window.BACK_LINK_TEXT,
            showImagesInCapture:false,
            allowFileSelectIfNoCapture:true,
        }
    },
    computed:{
        ...mapFields([
            
            'badgeData',
            'BadgeDesign',
            'loggedIn',
            'currentNav',
            'loggedInUser',
            'lastBadgeDesignReset'
            

    

        ]),
        
        footerTextBack(){
            if(window.FOOTER_TEXT_BACK==undefined){return ''}
            else{return window.FOOTER_TEXT_BACK}
        },
        //
        badgeIcon_footer(){
            if(this.BadgeDesign==undefined){return './../' + window.SCHOOL_LOGO}
            return this.imageBasePath + this.BadgeDesign.badgeIcon_Footer
        },
        hasBadge(){
            if(this.badgeData==undefined){return false}
            return true
        },
        hasBadgePerson(){
           if(!this.hasBadge){return false}
           if(this.badgeData.person==undefined){return false}
           return true
        },
        showBarcode(){
            if(this.BadgeDesign==undefined){return false}
            return this.BadgeDesign.showBarcode
        },
        hasAlerts(){
            if(!this.hasBadge){return false}
            if(this.badgeData.BadgeAlertList==undefined){return false}
            return this.badgeData.BadgeAlertList.length>0
        },
        barcodeType(){
            if(this.BadgeDesign==undefined){return "CODE39"}
            if(this.BadgeDesign.barcodeType==null){return "CODE39"}
            return this.BadgeDesign.barcodeType
        },
        showInactive(){
            if(this.badgeData.person.firstName==undefined){return false}
            return this.badgeData.person.isActive==false && !this.showOverrideStatus
        },
        showActive(){
            if(this.badgeData.person.firstName==undefined){return false}
            return this.badgeData.person.isActive==true && !this.showOverrideStatus
        },
        showOverrideStatus(){
            if(this.badgeData.person.firstName==undefined){return false}
            return this.badgeData.person.statusText_Override!=null
        },
        showStatus(){
            if(!this.hasBadgePerson){return false}
            return this.badgeData.person.status_ShowOnBadge
        },
        allowCapturePerson(){
            if(!this.hasBadge){return false}
            if(this.BadgeDesign==undefined){return false}
            var allowCapture = this.BadgeDesign.capturePersonImage
            var allowReplace = this.BadgeDesign.allowReplaceImage
            if(allowReplace && allowCapture){return true}
            if(allowCapture && !this.hasImagePerson){return true}
            if(this.imagePathPerson.includes('WM_')){return true}
            if(this.badgeData.person.personImageRejected){return true}
            return false
        },
        imagePathPerson(){
            if(!this.hasBadge){return}
            if(this.badgeData.person==undefined){return}
            var path = this.badgeData.person.personImageFileName;
            if(path==''){return}
            return this.imageBasePath + path;
        },
        hasImage(){
            
            if(this.imagePathPerson.includes('WM_')){return false}
            else{return true}
        },
        showActiveBlinking(){
            if(window.SHOW_ACTIVE_BLINKING==undefined){
                return false
            }else{return window.SHOW_ACTIVE_BLINKING}
        },
        personImageClass(){
            var cls = ""
            if(!this.hasBadge){return ""}
            if(this.badgeData.person.personImageValidated){return ""}
            if(this.hasPersonImage==false){return ""}
            if(this.badgeData.person.personImageRejected){cls= "watermarked_rej"}
            else{cls= "watermarked"}
            
            return cls
        },
        licenseClass(){
            if(this.BadgeDesign==undefined){return "logo hidebuttakespace"}
            if(this.BadgeDesign.showLicenseIcon){
                return "logodefault"
            }else{return "logodefault hidebuttakespace"}
        },
        vaccineClass(){
            if(this.BadgeDesign==undefined){return "logo hidebuttakespace"}
            if(this.BadgeDesign.showVaccineCardIcon){
                return "logodefault"
            }else{return "logodefault hidebuttakespace"}
        },
        schoolwebsite(){
            if(this.badgeData==undefined){return ""}
            var site = this.badgeData.location.website;
            if(site==undefined){return ""}
            if(!site.includes('http')){
                site = 'https://' + site
            }
            return site
        },
        //footer
        footLinkText(){
            if(!this.loggedIn){
                return "";
            }else if(this.currentNav=='front'){
                if(this.BadgeDesign==undefined){return " >>>"}
                return this.BadgeDesign.informationPageTitle + ' >>>';
                //return this.frontLinkText + ' >>>';
            }else if(this.currentNav=='back'){
                return '<<< ' + this.backLinkText;
            }
        },
        footLinkText_front(){
            if(!this.loggedIn){
                return "";
            }else{
                if(this.BadgeDesign==undefined){return " >>>"}
                return this.BadgeDesign.informationPageTitle + ' >>>';

            }
        },
        footLinkText_back(){
            if(!this.loggedIn){
                return "";
            }else{
                return '<<< ' + this.backLinkText;
            }
        },
        // dl front image
        imagePathLicenseFront(){
            if(!this.hasBadge){return}
            if(this.badgeData.person==undefined){return}
            var path = this.badgeData.person.licenseFrontFileName;
            if(path==''){return}
            return this.imageBasePath + path;
        },

        allowCaptureLicenseFront(){
            var allowCapture = this.BadgeDesign.captureLicenseFront
            var allowReplace = this.BadgeDesign.allowReplaceImage
            if(allowReplace && allowCapture){return true}
            if(allowCapture && !this.hasLicenseFront){return true}
            if(this.imagePathLicenseFront.includes('WM_')){return true}
            return false
        },
        licenseFrontClass(){
            if(!this.hasBadge){return ""}
            if(this.badgeData.person.licenseFrontValidated){return ""}
             if(this.hasLicenseFront==false){return ""}
            else{return "watermarked"}
        },

         // dl back image
        imagePathLicenseBack(){
            if(!this.hasBadge){return}
            if(this.badgeData.person==undefined){return}
            var path = this.badgeData.person.licenseBackFileName;
            if(path==''){return}
            return this.imageBasePath + path;
        },
        allowCaptureLicenseBack(){
            var allowCapture = this.BadgeDesign.captureLicenseBack
            var allowReplace = this.BadgeDesign.allowReplaceImage
            if(allowReplace && allowCapture){return true}
            if(allowCapture && !this.hasLicenseBack){return true}
            //if(this.imagePathLicenseBack.includes('WM_')){return true}
            return false
        },
        showLicenseBackImage(){
            var allowCapture = this.BadgeDesign.captureLicenseBack
            var allowReplace = this.BadgeDesign.allowReplaceImage
            if(allowCapture && allowReplace) {return true}
            if(!this.imagePathLicenseBack.includes('WM_')){return true}
            return false
        },
        licenseBackClass(){
            if(!this.hasBadge){return ""}
            if(this.badgeData.person.licenseBackValidated){return ""}
            if(this.hasLicenseBack==false){return ""}
            else{return "watermarked"}
        },
        allowFileSelect(){
            var allow = window.ALWAYS_ALLOW_FILE_SELECT
            if(allow==undefined){
                allow=false
            }
            return allow
        },
        autoLogoutIfNoPic(){
            
            if(window.AUTO_LOGOUT_IF_NO_PICTURE==undefined){
                return false
            }else{return window.AUTO_LOGOUT_IF_NO_PICTURE}
        },
        
        autoLogoutIfBadgeTypeID0(){
            
            if(window.AUTO_LOGOUT_IF_BADGETYPEID_0==undefined){
                return false
            }else{return window.AUTO_LOGOUT_IF_BADGETYPEID_0}
        },
        
        badgeTypeIDMessage0(){
            
            if(window.BADGETYPEID_MESSAGE_0==undefined){
                return 'Unable to access. Our records show that you do not have a mobile ID.'
            }else{return window.BADGETYPEID_MESSAGE_0}
        },
        badgeTypeIDMessage2(){
            
            if(window.BADGETYPEID_MESSAGE_2==undefined){
                return 'Unable to Access Mobile ID. Our records show that you already have a physical ID. To activate your Mobile ID, please visit the Admissions & Records office in person at either the Merced or Los Banos Campus.'
            }else{return window.BADGETYPEID_MESSAGE_2}
        },
    },
    methods:{
        //alert
       
        alertClass(alert){
            var c ="alertdiv" 
            if(alert.wasRead){c=c+" alertdivread"}
            else{c=c+ " alertdivunread"}
            if(alert.expanded){
                c=c+" alerttall"
            }else{c=c+" alertshort"}
            return c
        },
        showdown(alert){
            return this.alertislong(alert) && !alert.expanded
        },
        showup(alert){
            return this.alertislong(alert) && alert.expanded
        },
        alertislong(alert){
            if(alert.alertLine2!=null){
                return (alert.alertLine2.length>40)
            }else{return false}
            
        },
        togglebuttontext(alert){
            if(alert.expanded){return "&#9650"}
            else{return "&#9660"}
        },
        togglealert(alert){
            alert.expanded=!alert.expanded
        },
        //
        async saveinfoitem(id, text){
            let req = {
                id:this.loggedInUser.badgeId,
                BadgeInformation:{
                    id:id,
                    infoText:text
                }
                
            }

            var response = await this.callAPI(req,'saveinfoitem')
            //handle response
            if(response.Successful){
                this.getBadgeDetail();  
            
            }else{
                this.responseMessage = response.Message
            }
        },
        async dismissalert(alert){
            let req = {
                badgeId:this.loggedInUser.badgeId,
                badgeAlertId:alert.id
            }

            var response = await this.callAPI(req,'dismissalert')
            //handle response
            if(response.Successful){
                this.getBadgeDetail();  
            }else{
                this.responseMessage = response.Message
            }
        },
        async getBadgeDetail_Light(){
            //if not logged in don't do this
            if(!this.loggedIn){
                console.log('skip refresh. not logged in')
                return
            }

            //if this is a -1 for badge design, then mark it as last reset.  If last reset was yesterday, then do a full refresh with new badge design
            var todaydate = this.$options.filters.formatDateForInputToday()
            if(this.lastBadgeDesignReset < todaydate){
                console.log('full badge and badge design refresh')
                this.lastBadgeDesignReset=todaydate
                this.badgeData.person.badgeDesignID=-1
                this.getBadgeDetail()
                return
            }else{
                console.log('light refresh only')

                let req = {
                    badgeId:this.loggedInUser.badgeId,
                }
    
                //call api
                var response = await this.callAPI(req,'badgelight')
                //handle response
                if(response.Successful){
                    //only update the specific data we need all the time
                    this.badgeData.BadgeAlertList=response.BadgeAlertList
                    this.badgeData.person.isActive=response.person.isActive
                    this.badgeData.person.statusText_Override=response.person.statusText_Override
                    
                }else{
                    this.responseMessage = response.Message
                    
                }
            }
        },


        async getBadgeDetail(){
            console.log('get badge detail ' + this.loggedInUser.badgeId)
            
            //check for app updates
            this.checkLastUpdate()

            this.responseMessage=''
            //reset
            this.hasPersonImage=true
            this.hasLicenseFront=true
            this.hasLicenseBack=true
            this.hasVaccineCard=true

            //setup request
            //if we have a style id, provide it
            var styleId=-1
            if(this.badgeData.person!=undefined){
                styleId=this.badgeData.person.badgeDesignID
            }

            let req = {
                personId:this.loggedInUser.id,
                badgeId:this.loggedInUser.badgeId,
                badgeDesignId_previous:styleId
            }

            //call api
            var response = await this.callAPI(req,'badge')
            //handle response
            if(response.Successful){
                this.badgeData=response

                //if we are auto logging out if no pic...do that now
                if(this.autoLogoutIfNoPic && this.loggedIn){
                    if(!this.hasImage){
                        this.loggedIn=false
                        this.responseMessage="You’ll need to visit Admissions & Records to have your photo taken before your mobile ID can be activated."
                        return
                    }
                }

                //if we are checking badge type, 
                if(this.autoLogoutIfBadgeTypeID0 && this.loggedIn){
                    console.log('badgetype ' + this.badgeData.person.badgeTypeId)
                    if(this.badgeData.person.badgeTypeId==0){
                        this.loggedIn=false
                        this.responseMessage=this.badgeTypeIDMessage0
                        return
                    }
                    
                    if(this.badgeData.person.badgeTypeId==2){
                        console.log('badgetype ' + this.badgeData.person.badgeTypeId)
                        this.loggedIn=false
                        this.responseMessage=this.badgeTypeIDMessage2
                        return
                    }
                }

                //this.currentNav='front' 
                this.clearTempImages()
                this.updateStyle()
                if(this.BadgeDesign.showTimeclock){
                    this.GetTimeHistory()
                }
                if(this.showDocsAfterBadge){
                    this.showDocsAfterBadge=false //single use
                    this.showdocuments();
                }
            }else{
                this.responseMessage = response.Message
                this.logout();
            }
   
        },
        updateStyle(){

            //IF needed
            if(this.badgeData.person.refreshBadgeDesign){
                //set colors

                this.BadgeDesign=this.badgeData.BadgeDesign

                if(this.BadgeDesign==undefined){ return;}
                this.overrideColors(this.BadgeDesign.titleTextColor,this.BadgeDesign.mainTextColor,
                    this.BadgeDesign.menuTextColor,this.BadgeDesign.titleBackgroundColor,
                    this.BadgeDesign.mainBackgroundColor,this.BadgeDesign.backTextColor,this.BadgeDesign.BG_Footer_BackColor, this.BadgeDesign.BG_Footer_FrontColor, 
                        this.BadgeDesign.BG_Footer_BarColor, this.BadgeDesign.Text_Footer_BackColor, this.BadgeDesign.Text_Footer_FrontColor, this.BadgeDesign.Text_Footer_BarColor)

                this.setbackgroundimage()
               // this.setBackgroundImage(this.imageBasePath + this.BadgeDesign.badgeBackground)

            }
        },
        async checkLastUpdate(){
            var needsClear =false
    
            //get the last update value from config
            var lastUpdate = '' 
    
            //from api
            try {
              var response = await this.callAPI(null,'lastupdatedate')
                //handle response
                if(response.Successful){
                  lastUpdate = response.StringResponse
                }
    
            } catch (error) {
              
            }
    
    
            
            //if we don't have a setting, then don't do anything
            if(lastUpdate==''){return}
    
    
            //get last update value from localstorage
            var storedLastUpdate = ''
            storedLastUpdate=localStorage.getItem('lastUpdate')
    
            console.log('lastupdate ' + lastUpdate + ' ' + storedLastUpdate)
    
            if(storedLastUpdate==undefined){needsClear=true}
            else if(storedLastUpdate!=lastUpdate){needsClear=true}
    
            //if we need to clear...
            if(needsClear){
              this.wasUpdated=true
            }
            
            //store the last update
            localStorage.setItem('lastUpdate',lastUpdate)
    
          },

          //images
          //IMAGES
        
        saveimg_selfie(file,url){
            this.capturedPerson=file
            this.capturedPersonURL=url
            this.storeImage(this.badgeData.person.personImageFileName, file, file.name,"person")
        },
        saveimg_LicenseFront(file,url){
            this.capturedLicenseFront=file
            this.capturedLicenseFrontURL=url
            this.storeImage(this.badgeData.person.licenseFrontFileName, file, file.name,"front")
        },
       
        saveimg_LicenseBack(file,url){
            this.capturedLicenseBack=file
            this.capturedLicenseBackURL=url
            this.storeImage(this.badgeData.person.licenseBackFileName, file, file.name,"back")
        },
      
        saveimg_Vaccine(file,url){
            this.capturedVaccineCard=file
            this.capturedVaccineCardURL=url
            this.storeImage(this.badgeData.person.vaccineCardFileName, file, file.name,"vaccine")
        },
        async storeImage(filename,file, name,type){
             var bId=this.badgeData.person.badgeId
            var postParams = new FormData();

            postParams.append(filename,file,name);
            
            postParams.append('badgeId',bId);
            postParams.append('type',type);

            var response = await this.callAPI(postParams,'saveimage')
            //handle response
            if(response.Successful){
                this.getBadgeDetail();  
            }else{
                this.responseMessage = response.Message
            }
             
        },
        
        clearTempImages(){
            this.capturedPerson=null
            this.capturedLicenseBack=null 
            this.capturedLicenseBack=null
            this.capturedVaccineCard=null
            this.capturedPersonURL=null
            this.capturedLicenseBackURL=null 
            this.capturedLicenseBackURL=null
            this.capturedVaccineCardURL=null
        },
        async getImageBasePath(){
            //call api
            var response = await this.callAPI(null,'imagepath')
            //handle response
            if(response.Successful){
                this.imageBasePath = response.StringResponse
            }else{
                this.responseMessage = response.Message
            }
        },
    }
    
    

}